module.exports = __webpack_public_path__ + "static/media/image7.56e1a76d.jpg";